import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
 


@Component({
    selector: 'open-booking-menu',
    templateUrl: './open-booking-menu.html',
    styles: [`.mat-toolbar {
                min-height: 50px !important;
                height: 50px !important;
                padding:0 6px !important;
            }
            .mat-toolbar-row {
                min-height: 50px !important;
                height: 50px !important;
            }
            .filterStickey{
                position: sticky;
                top: 0;
                z-index: 999;
                background: #e6e6e6;}`
            ],
})
export class OpenBookingMenuComponent implements OnInit {

    @Input() _activeMenu: string = '';
    @Output() routeTypeEmit= new EventEmitter();

    public routeType = ''; 
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {

        // var routeType = new URLSearchParams(window.location.search).get('routeType');

       

    }


    ngOnInit(): void {

    }

 

    pageNavigate(path, $event) {

        
        const urlPath = 'organization/transport-manager/reports/';
        // this.router.navigate([urlPath + 're-route']);
        setTimeout(()=>{
            this.router.navigate([urlPath + path]);
        },10);
        // this.router.navigate(['/heroes', { id: heroId }]);
    }

}